import React from "react";
import PropTypes from "prop-types";
import "../Hero/Hero.css";

const Hero = (props) => {
  Hero.propTypes = {
    value: PropTypes.string,
  };

  const bannerSize =
    props.value === "Forest Pest Conditions" ? "large" : "small";

  return (
    <div
      alt=""
      className={"usa-hero hero-container hero-" + bannerSize}
      aria-hidden="true"
    >
      <div className="grid-container">
        <div className="font-heading-2xl">{props.value}</div>
      </div>
    </div>
  );
};
export default Hero;
